import { Component, OnInit, Input } from '@angular/core';
import { ProgramAndServiceDetail } from '../../student360/programs-and-services/programs-and-services-detail.model';

@Component({
  selector: 'program-and-service-fields',
  templateUrl: './program-and-service-fields.component.html',
  styleUrls: ['./program-and-service-fields.component.css']
})
export class ProgramAndServiceFieldsComponent implements OnInit {

  @Input() field: ProgramAndServiceDetail;
  fieldLengthString = '200';
  constructor() { }

  ngOnInit() {
    this.fieldLengthString = this.field.FieldLength.toString();
  }

}
